export const FETCH_CONFIGURATIONS_REQUEST = 'FETCH_CONFIGURATIONS_REQUEST';
export const FETCH_CONFIGURATIONS_SUCCESS = 'FETCH_CONFIGURATIONS_SUCCESS';
export const FETCH_CONFIGURATIONS_FAILURE = 'FETCH_CONFIGURATIONS_FAILURE';

export const FETCH_CONFIGURATION_REQUEST = 'FETCH_CONFIGURATION_REQUEST';
export const FETCH_CONFIGURATION_SUCCESS = 'FETCH_CONFIGURATION_SUCCESS';
export const FETCH_CONFIGURATION_FAILURE = 'FETCH_CONFIGURATION_FAILURE';

export const CREATE_CONFIGURATION_REQUEST = 'CREATE_CONFIGURATION_REQUEST';
export const CREATE_CONFIGURATION_SUCCESS = 'CREATE_CONFIGURATION_SUCCESS';
export const CREATE_CONFIGURATION_FAILURE = 'CREATE_CONFIGURATION_FAILURE';

export const UPDATE_CONFIGURATION_REQUEST = 'UPDATE_CONFIGURATION_REQUEST';
export const UPDATE_CONFIGURATION_SUCCESS = 'UPDATE_CONFIGURATION_SUCCESS';
export const UPDATE_CONFIGURATION_FAILURE = 'UPDATE_CONFIGURATION_FAILURE';

export const DELETE_CONFIGURATION_REQUEST = 'DELETE_CONFIGURATION_REQUEST';
export const DELETE_CONFIGURATION_SUCCESS = 'DELETE_CONFIGURATION_SUCCESS';
export const DELETE_CONFIGURATION_FAILURE = 'DELETE_CONFIGURATION_FAILURE';

export const ACTIVE_CONFIGURATION_REQUEST = 'ACTIVE_CONFIGURATION_REQUEST';
export const ACTIVE_CONFIGURATION_SUCCESS = 'ACTIVE_CONFIGURATION_SUCCESS';
export const ACTIVE_CONFIGURATION_FAILURE = 'ACTIVE_CONFIGURATION_FAILURE';

export const DOWNLOAD_CONFIGURATION_REQUEST = 'DOWNLOAD_CONFIGURATION_REQUEST';
export const DOWNLOAD_CONFIGURATION_SUCCESS = 'DOWNLOAD_CONFIGURATION_SUCCESS';
export const DOWNLOAD_CONFIGURATION_FAILURE = 'DOWNLOAD_CONFIGURATION_FAILURE';

export const FETCH_MAX_EVENTID_REQUEST = 'FETCH_MAX_EVENTID_REQUEST';
export const FETCH_MAX_EVENTID_SUCCESS = 'FETCH_MAX_EVENTID_SUCCESS';
export const FETCH_MAX_EVENTID_FAILURE = 'FETCH_MAX_EVENTID_FAILURE';

export const FETCH_ACTIVE_CONFIGURATION_ID_REQUEST = 'FETCH_ACTIVE_CONFIGURATION_ID_REQUEST';
export const FETCH_ACTIVE_CONFIGURATION_ID_SUCCESS = 'FETCH_ACTIVE_CONFIGURATION_ID_SUCCESS';
export const FETCH_ACTIVE_CONFIGURATION_ID_FAILURE = 'FETCH_ACTIVE_CONFIGURATION_ID_FAILURE';

export const FETCH_CONFIGURATIONS_BY_COMPANY_REQUEST = 'FETCH_CONFIGURATIONS_BY_COMPANY_REQUEST';
export const FETCH_CONFIGURATIONS_BY_COMPANY_SUCCESS = 'FETCH_CONFIGURATIONS_BY_COMPANY_SUCCESS';
export const FETCH_CONFIGURATIONS_BY_COMPANY_FAILURE = 'FETCH_CONFIGURATIONS_BY_COMPANY_FAILURE';

export const FETCH_CONFIGURATIONS_BY_COUNTRY_REQUEST = 'FETCH_CONFIGURATIONS_BY_COUNTRY_REQUEST';
export const FETCH_CONFIGURATIONS_BY_COUNTRY_SUCCESS = 'FETCH_CONFIGURATIONS_BY_COUNTRY_SUCCESS';
export const FETCH_CONFIGURATIONS_BY_COUNTRY_FAILURE = 'FETCH_CONFIGURATIONS_BY_COUNTRY_FAILURE';

export const FETCH_CONFIGURATIONS_BY_USER_REQUEST = 'FETCH_CONFIGURATIONS_BY_USER_REQUEST';
export const FETCH_CONFIGURATIONS_BY_USER_SUCCESS = 'FETCH_CONFIGURATIONS_BY_USER_SUCCESS';
export const FETCH_CONFIGURATIONS_BY_USER_FAILURE = 'FETCH_CONFIGURATIONS_BY_USER_FAILURE';
